import { render } from "./ProgressRound.vue?vue&type=template&id=364988ab&scoped=true"
import script from "./ProgressRound.vue?vue&type=script&lang=js"
export * from "./ProgressRound.vue?vue&type=script&lang=js"

import "./ProgressRound.vue?vue&type=style&index=0&id=364988ab&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-364988ab"

export default script